export default "__VITE_ASSET__DUr2ZO9Q__"